import React from 'react';
import styled, { keyframes } from 'styled-components';

const BooksSection = () => {
  return (
    <Wrapper>
      <Container>
        <Content>
          <HeaderSection>
            <Title>Books From the Chronicles of G.A.I.A.</Title>
            <Subtitle>
              Where B.E.L.A. was born. The award-winning middle-grade series that turns eco-anxiety into curiosity, courage, and care.
            </Subtitle>
          </HeaderSection>          <Grid>
            <BookCard>
              <ImageContainer>
                <Image src="/Future+Hack_Cover.webp" alt="Future Hack" />
              </ImageContainer>
              <BookContent>
                <BookTitle>Future Hack</BookTitle>
                <Description>
                  Recruited by a mysterious time traveler, a group of kids race to protect the planet. As they uncover environmental crimes, Chronnite—a ruthless corporation—will do anything to stop them. Can these young heroes save the future?
                </Description>
              </BookContent>
            </BookCard>
            <BookCard>
              <ImageContainer>
                <Image src="/2Norbu's+Secret_FH.webp" alt="Norbu's Secret" />
              </ImageContainer>
              <BookContent>
                <BookTitle>Norbu's Secret</BookTitle>
                <Description>
                  The team travels to Ecuador to protect endangered jaguars with Achuar youth, but their link to Norbu—the enigmatic time traveler—suddenly disappears. Stranded in the rainforest, the kids must depend on each other to expose Chronnite’s sinister plans.
                </Description>
              </BookContent>
            </BookCard>
          </Grid>
          <BottomButton href="https://www.danaklisanin.com/chroniclesofgaia" target="_blank" rel="noopener noreferrer">
            Explore Chronicles of G.A.I.A
          </BottomButton>
        </Content>
      </Container>
    </Wrapper>
  );
};

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const float = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
`;

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const Wrapper = styled.section`
  width: 100vw;
  background: linear-gradient(135deg,rgb(37, 63, 121) 0%,rgb(47, 73, 145) 50%,rgb(62, 96, 208) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  padding: 0;
  @media (max-width: 768px) {
    padding: 0;
  }
`;

const Container = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 32px;
  @media (max-width: 768px) {
    padding: 0 12px;
  }
`;

const Content = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 80px 32px 60px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;

  @media (max-width: 1280px) {
    padding: 70px 28px 55px 28px;
    gap: 36px;
  }

  @media (max-width: 1024px) {
    padding: 60px 24px 45px 24px;
    gap: 32px;
  }

  @media (max-width: 900px) {
    padding: 55px 22px 40px 22px;
    gap: 28px;
  }

  @media (max-width: 768px) {
    padding: 50px 20px 38px 20px;
    gap: 26px;
  }

  @media (max-width: 640px) {
    padding: 45px 18px 32px 18px;
    gap: 22px;
  }

  @media (max-width: 480px) {
    padding: 40px 16px 28px 16px;
    gap: 20px;
  }

  @media (max-width: 375px) {
    padding: 36px 12px 24px 12px;
    gap: 18px;
  }
`;

const HeaderSection = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 900px;
  margin: 0 auto;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: 800;
  line-height: 1.1;
  margin: 0 0 8px 0;
  color: white;
  text-align: center;
  @media (max-width: 1024px) {
    font-size: 2rem;
  }
  @media (max-width: 600px) {
    font-size: 1.3rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.18rem;
  color:#ffffff;
  line-height: 1.7;
  font-weight: 400;
  margin: 0 0 8px 0;
  text-align: center;
  @media (max-width: 600px) {
    font-size: 1rem;
  }
`;

const Grid = styled.div`
  display: flex;
  gap: 40px;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: 1280px) {
    gap: 35px;
  }

  @media (max-width: 1024px) {
    gap: 30px;
  }

  @media (max-width: 900px) {
    gap: 26px;
  }

  @media (max-width: 768px) {
    gap: 24px;
  }

  @media (max-width: 640px) {
    gap: 20px;
  }

  @media (max-width: 480px) {
    gap: 16px;
  }

  @media (max-width: 375px) {
    gap: 12px;
  }
`;

const BookCard = styled.div`
  background: #f1f5f9;
  border-radius: 18px;
  box-shadow: 0 2px 8px rgba(30, 64, 175, 0.04);
  overflow: hidden;
  width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-6px) scale(1.03);
    box-shadow: 0 8px 32px rgba(30, 64, 175, 0.10);
  }

  @media (max-width: 1024px) {
    width: 380px;
  }

  @media (max-width: 900px) {
    width: 350px;
  }

  @media (max-width: 768px) {
    width: 90%;
    max-width: 400px;
  }

  @media (max-width: 640px) {
    width: 90vw;
    min-width: 0;
  }

  @media (max-width: 480px) {
    width: 92%;
  }

  @media (max-width: 375px) {
    width: 95%;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  aspect-ratio: 6.5/6;
  position: relative;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const ImageOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(120deg, rgba(59,130,246,0.08) 0%, rgba(96,165,250,0.12) 100%);
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;

  ${BookCard}:hover & {
    opacity: 1;
  }
`;

const OverlayText = styled.span`
  color: #2563eb;
  font-weight: 700;
  font-size: 1.1rem;
  background: rgba(255,255,255,0.8);
  padding: 6px 18px;
  border-radius: 999px;
`;

const BookContent = styled.div`
  padding: 18px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

const BookTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 6px 0;
`;

const Description = styled.p`
  font-size: 0.8rem;
  color: #64748b;
  font-align: justify;
  line-height: 1.5;
  margin: 0;
`;

const BottomButton = styled.a`
  background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%);
  color: #253f79;
  border: 2px solid #ffffff;
  border-radius: 50px;
  padding: 14px 40px;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  margin-top: 20px;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);
    background: linear-gradient(135deg, #f1f5f9 0%, #ffffff 100%);
    border-color: #ffffff;
  }

  &:active {
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    padding: 12px 32px;
    font-size: 1rem;
  }

  @media (max-width: 480px) {
    padding: 11px 28px;
    font-size: 0.95rem;
  }
`;

export default BooksSection;